const Colors = {
    white: "#FFFFFF",
    black: "#2D2D2D",
    blue: "#6574FB",
    brandColor: '#707070',
    appRed: "#bd2132",
    border: "#3D35D1",
    headingBlue: "#102B5C",
    newsLetterBg: "#FFECEE",
    textGrey: "#8E8E8E",
    placeHolderText: "#B4B4B4",
    inputBg: "#F6F8FC",
  };
  
  export default Colors;
  